import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Checkbox, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  checkboxStyle: {
    color: "gray",
    paddingBottom: "6.2px",
  },
  checkboxLabel: {
    fontSize: "14px",
  },
}));

const checkboxComponent = ({
  label,
  labelPlacement,
  checkboxOnchange,
  checkboxName,
  checkboxColor,
  checkboxSize,
  checkboxDefaultChecked = false,
}) => {
  const classes = useStyles();

  return (
    <FormControlLabel
      classes={{
        label: classes.checkboxLabel,
      }}
      control={
        <Checkbox
          defaultChecked={checkboxDefaultChecked}
          disableRipple
          onChange={checkboxOnchange}
          name={checkboxName}
          color={checkboxColor}
          size={checkboxSize}
          classes={{ root: classes.checkboxStyle }}
        />
      }
      label={label}
      labelPlacement={labelPlacement}
    />
  );
};

export default checkboxComponent;
